import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../../services/api";


// ======================================================
// 🔹 REGISTER USER
// ======================================================
export const registerUser = createAsyncThunk(
  "auth/registerUser",
  async (formData, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/auth/register", formData);
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Registration failed"
      );
    }
  }
);


// ======================================================
// 🔹 ADMIN / SUB-ADMIN LOGIN
// ======================================================
export const adminLogin = createAsyncThunk(
  "auth/adminLogin",
  async (formData, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/auth/admin/login", formData);
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Login failed"
      );
    }
  }
);


// ======================================================
// 🔹 SEND OTP
// ======================================================
export const sendOtp = createAsyncThunk(
  "auth/sendOtp",
  async (formData, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/auth/login/send-otp", formData);
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "OTP sending failed"
      );
    }
  }
);


// ======================================================
// 🔹 VERIFY OTP
// ======================================================
export const verifyOtp = createAsyncThunk(
  "auth/verifyOtp",
  async (formData, { rejectWithValue }) => {
    try {
      const { data } = await api.post("/auth/login/verify-otp", formData);
      return data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "OTP verification failed"
      );
    }
  }
);


// ======================================================
// 🔹 SLICE
// ======================================================
const authSlice = createSlice({
  name: "auth",
  initialState: {
    user: null,
    token: null,
    loading: false,
    message: null,
    error: null,
  },

  reducers: {
    clearAuthMessages: (state) => {
      state.message = null;
      state.error = null;
    },

    logoutUser: (state) => {
      state.user = null;
      state.token = null;
    },

    // ⭐ NEW — RESTORE USER FROM STORAGE OR UPDATE USER
    setUser: (state, action) => {
      state.user = action.payload.user || null;
      state.token = action.payload.token || null;
    }
  },

  extraReducers: (builder) => {
    builder
      // REGISTER
      .addCase(registerUser.pending, (state) => {
        state.loading = true;
      })
      .addCase(registerUser.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message;
      })
      .addCase(registerUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // ADMIN LOGIN
      .addCase(adminLogin.pending, (state) => {
        state.loading = true;
      })
      .addCase(adminLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message;
        state.token = action.payload.token;
        state.user = action.payload.admin;
      })
      .addCase(adminLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // SEND OTP
      .addCase(sendOtp.pending, (state) => {
        state.loading = true;
      })
      .addCase(sendOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message;
      })
      .addCase(sendOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // VERIFY OTP
      .addCase(verifyOtp.pending, (state) => {
        state.loading = true;
      })
      .addCase(verifyOtp.fulfilled, (state, action) => {
        state.loading = false;
        state.message = action.payload.message;
        state.token = action.payload.token;
        state.user = action.payload.user;
      })
      .addCase(verifyOtp.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { clearAuthMessages, logoutUser, setUser } = authSlice.actions;
export default authSlice.reducer;
